<template>
  <svg
    fill="none"
    height="40"
    viewBox="0 0 40 40"
    width="40"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clip-rule="evenodd"
      d="M26.7694 11.0023C26.6798 11.0008 26.59 11 26.5 11C17.9396 11 11 17.9396 11 26.5C11 26.59 11.0008 26.6798 11.0023 26.7694C4.73974 25.5979 0 20.1025 0 13.5C0 6.04416 6.04416 0 13.5 0C20.1025 0 25.5979 4.73974 26.7694 11.0023Z"
      fill="#FF9500"
      fill-rule="evenodd"
    />
    <path
      clip-rule="evenodd"
      d="M8.84 7C8.31726 7 7.82224 7.09411 7.46719 7.42852C7.10449 7.77013 7 8.25469 7 8.76V18.24C7 18.7453 7.10449 19.2299 7.46719 19.5715C7.82224 19.9059 8.31726 20 8.84 20H11.26C11.781 20 12.2745 19.9065 12.6293 19.5748C12.7614 19.3107 12.9008 19.0509 13.0473 18.7957C13.0852 18.6178 13.1 18.4304 13.1 18.24V8.76C13.1 8.25469 12.9955 7.77013 12.6328 7.42852C12.2778 7.09411 11.7827 7 11.26 7H8.84ZM8 8.76C8 8.36531 8.08551 8.21987 8.15281 8.15648C8.22776 8.08589 8.40274 8 8.84 8H11.26C11.6973 8 11.8722 8.08589 11.9472 8.15648C12.0145 8.21987 12.1 8.36531 12.1 8.76V18.24C12.1 18.6347 12.0145 18.7801 11.9472 18.8435C11.8722 18.9141 11.6973 19 11.26 19H8.84C8.40274 19 8.22776 18.9141 8.15281 18.8435C8.08551 18.7801 8 18.6347 8 18.24V8.76Z"
      fill="currentcolor"
      fill-rule="evenodd"
    />
    <path
      clip-rule="evenodd"
      d="M15.7404 7C15.22 7 14.7261 7.09451 14.3708 7.42786C14.0075 7.76869 13.9004 8.25259 13.9004 8.76V17.4709C14.2123 17.0364 14.5462 16.6186 14.9004 16.2193V8.76C14.9004 8.36741 14.9866 8.22131 15.055 8.15714C15.1314 8.08549 15.3074 8 15.7404 8H18.1604C18.5977 8 18.7726 8.08589 18.8476 8.15648C18.9149 8.21987 19.0004 8.36531 19.0004 8.76V12.9321C19.3267 12.7514 19.6602 12.582 20.0004 12.4247V8.76C20.0004 8.25469 19.8959 7.77013 19.5332 7.42852C19.1782 7.09411 18.6831 7 18.1604 7H15.7404Z"
      fill="currentcolor"
      fill-rule="evenodd"
    />
    <rect
      fill="#43B284"
      height="27"
      rx="13.5"
      width="27"
      x="13"
      y="13"
    />
    <path
      d="M33.1473 30.7202C33.1473 30.9602 33.094 31.2068 32.9807 31.4468C32.8673 31.6868 32.7207 31.9135 32.5273 32.1268C32.2007 32.4868 31.8407 32.7468 31.434 32.9135C31.034 33.0802 30.6007 33.1668 30.134 33.1668C29.454 33.1668 28.7273 33.0068 27.9607 32.6802C27.194 32.3535 26.4273 31.9135 25.6673 31.3602C24.9007 30.8002 24.174 30.1802 23.4807 29.4935C22.794 28.8002 22.174 28.0735 21.6207 27.3135C21.074 26.5535 20.634 25.7935 20.314 25.0402C19.994 24.2802 19.834 23.5535 19.834 22.8602C19.834 22.4068 19.914 21.9735 20.074 21.5735C20.234 21.1668 20.4873 20.7935 20.8407 20.4602C21.2673 20.0402 21.734 19.8335 22.2273 19.8335C22.414 19.8335 22.6007 19.8735 22.7673 19.9535C22.9407 20.0335 23.094 20.1535 23.214 20.3268L24.7607 22.5068C24.8807 22.6735 24.9673 22.8268 25.0273 22.9735C25.0873 23.1135 25.1207 23.2535 25.1207 23.3802C25.1207 23.5402 25.074 23.7002 24.9807 23.8535C24.894 24.0068 24.7673 24.1668 24.6073 24.3268L24.1007 24.8535C24.0273 24.9268 23.994 25.0135 23.994 25.1202C23.994 25.1735 24.0007 25.2202 24.014 25.2735C24.034 25.3268 24.054 25.3668 24.0673 25.4068C24.1873 25.6268 24.394 25.9135 24.6873 26.2602C24.9873 26.6068 25.3073 26.9602 25.654 27.3135C26.014 27.6668 26.3607 27.9935 26.714 28.2935C27.0607 28.5868 27.3473 28.7868 27.574 28.9068C27.6073 28.9202 27.6473 28.9402 27.694 28.9602C27.7473 28.9802 27.8007 28.9868 27.8607 28.9868C27.974 28.9868 28.0607 28.9468 28.134 28.8735L28.6407 28.3735C28.8073 28.2068 28.9673 28.0802 29.1207 28.0002C29.274 27.9068 29.4273 27.8602 29.594 27.8602C29.7207 27.8602 29.854 27.8868 30.0007 27.9468C30.1473 28.0068 30.3007 28.0935 30.4673 28.2068L32.674 29.7735C32.8473 29.8935 32.9673 30.0335 33.0407 30.2002C33.1073 30.3668 33.1473 30.5335 33.1473 30.7202Z"
      stroke="currentcolor"
      stroke-miterlimit="10"
    />
    <path
      d="M30.8333 24.5003C30.8333 24.1003 30.52 23.487 30.0533 22.987C29.6267 22.527 29.06 22.167 28.5 22.167"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M33.1667 24.5002C33.1667 21.9202 31.08 19.8335 28.5 19.8335"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
